import { StakeholderTBDName } from '../../../data-models/captable2.data-model';
import { ViewModelInvestmentType } from '../../../schemas/common-schema-defs';
import { Option } from '../../../schemas/Options.schema';
import { getInvestmentKey, ShareClass } from '../../../view-models/captable.view-model';

export const UNISSUED_OPTIONS_ROW_LABEL = `Unissued Options (${StakeholderTBDName})`;

function getUnissuedOptionClasses(shareClasses: ShareClass[]) {
  return shareClasses.filter(
    (shareClass): shareClass is Option =>
      shareClass.type === ViewModelInvestmentType.options &&
      Number((shareClass as Option).totalOptionPool) > 0
  );
}

// The BE persists each option class's totalOptionPool as a hidden "Stakeholder - TBD" line on every
// save; this row makes that allocation visible in the wizard so grants aren't entered twice.
export function getUnissuedOptionsRow(shareClasses: ShareClass[]): Record<string, number> | null {
  const row = getUnissuedOptionClasses(shareClasses).reduce(
    (acc, shareClass) => {
      acc[getInvestmentKey(shareClass)] = Number(shareClass.totalOptionPool);
      return acc;
    },
    {} as Record<string, number>
  );

  return Object.keys(row).length > 0 ? row : null;
}

export interface IUnissuedOptionsWarning {
  name: string;
  unissued: number;
  granted: number;
}

export function getUnissuedOptionsWarnings(
  shareClasses: ShareClass[],
  investmentRows: Record<string, unknown>[]
): IUnissuedOptionsWarning[] {
  return getUnissuedOptionClasses(shareClasses).reduce((warnings, shareClass) => {
    const key = getInvestmentKey(shareClass);
    const granted = investmentRows.reduce((total, row) => {
      const value = Number(row[key]);
      return Number.isFinite(value) ? total + value : total;
    }, 0);

    if (granted > 0) {
      warnings.push({ name: shareClass.name, unissued: Number(shareClass.totalOptionPool), granted });
    }
    return warnings;
  }, [] as IUnissuedOptionsWarning[]);
}
